<template>
  <div class="order-info">
    <div class="title">订单详情</div>
    <div class="detail">
      <div class="title">
        <div>商品信息</div>
      </div>
      <div class="goods">
        <div class="goods_item" v-for="(item, index) in info.orderGoods" :key="index" :data-id="item.goods_id">
          <div class="goods_img"><img :src="$url.cdn(item.goods_image)" :alt="item.goods_name"></div>
          <div class="goods_info">
            <div class="goods_name">名称：{{item.goods_name}}</div>
            <div class="goods_sn">编号：{{item.goods_sn}}</div>
            <div class="goods_specs">规格：{{item.goods_specs}} × {{item.goods_amount}}</div>
            <div class="goods_total">价格：￥{{item.goods_total}}</div>
            <div class="goods_total" v-if="parseFloat(info.discount) < 1">折扣价：￥{{(parseFloat(item.goods_total) * parseFloat(info.discount)).toFixed(2)}}</div>
          </div>
        </div>
      </div>
      <div class="title">
        <div>订单信息</div>
      </div>
      <div class="order-box">
        <div class="order-line">
          <div class="line-title">订单号</div>
          <div class="line-value">{{info.order_no}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">（不含邮费）总费用</div>
          <div class="line-value">￥{{info.total}}</div>
        </div>
        <div class="order-line" v-if="parseFloat(info.discount) < 1">
          <div class="line-title">会员折扣</div>
          <div class="line-value">{{(parseFloat(info.discount)*10)}}折</div>
        </div>
        <div v-if="parseFloat(info.discount) < 1" class="order-line">
          <div class="line-title">（不含邮费）折后费用</div>
          <div class="line-value">￥{{info.discount_price}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">状态</div>
          <div class="line-value">{{info.status_text}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">申请时间</div>
          <div class="line-value">{{info.submit_time_text}}</div>
        </div>
      </div>
      <div class="title">
        <div>收件信息</div>
      </div>
      <div class="order-box">
        <div class="order-line">
          <div class="line-title">姓名</div>
          <div class="line-value">{{info.orderContact.name}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">电话</div>
          <div class="line-value">{{info.orderContact.mobile}}</div>
        </div>
        <div v-if="info.orderContact.email" class="order-line">
          <div class="line-title">邮箱</div>
          <div class="line-value">{{info.orderContact.email}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">地址</div>
          <div class="line-value">{{info.orderContact.address}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.logistics_name">
          <div class="line-title">承运商</div>
          <div class="line-value">{{info.orderContact.logistics_name}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.logistics_order_no">
          <div class="line-title">物流单号</div>
          <div class="line-value">{{info.orderContact.logistics_order_no}}</div>
        </div>
      </div>
      <div class="title">
        <div>开票信息</div>
      </div>
      <div class="order-box">
        <div class="order-line">
          <div class="line-title">类型</div>
          <div class="line-value">{{info.orderContact.type_text}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">机构名称</div>
          <div class="line-value">{{info.orderContact.nickname}}</div>
        </div>
        <div class="order-line">
          <div class="line-title">单位税号</div>
          <div class="line-value">{{info.orderContact.id_no}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.legal_person">
          <div class="line-title">法人</div>
          <div class="line-value">{{info.orderContact.legal_person}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.deposit_bank">
          <div class="line-title">开户银行</div>
          <div class="line-value">{{info.orderContact.deposit_bank}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.bank_account">
          <div class="line-title">银行账号</div>
          <div class="line-value">{{info.orderContact.bank_account}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.business_address">
          <div class="line-title">企业地址</div>
          <div class="line-value">{{info.orderContact.business_address}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.enterprise_telephone">
          <div class="line-title">企业电话</div>
          <div class="line-value">{{info.orderContact.enterprise_telephone}}</div>
        </div>
        <div class="order-line" v-if="info.orderContact.invoice">
          <div class="line-title">发票</div>
          <div class="line-value fileBox">
            <p v-for="(item, index) in info.orderContact.invoice" :key="index">
              <a target="_blank" :href="$url.cdn(item.url)" title="点击查看文件">{{item.name}}</a>
            </p>
          </div>
        </div>
      </div>
      <div class="title" v-if="info.orderInfo">
        <div>合同信息</div>
      </div>
      <div class="order-box" v-if="info.orderInfo">
        <div class="order-line" v-if="info.orderInfo.contract_no">
          <div class="line-title">编号</div>
          <div class="line-value">{{info.orderInfo.contract_no}}</div>
        </div>
        <div class="order-line" v-if="info.orderInfo.contract_name">
          <div class="line-title">名称</div>
          <div class="line-value">{{info.orderInfo.contract_name}}</div>
        </div>
        <div class="order-line" v-if="info.orderInfo.status_text">
          <div class="line-title">状态</div>
          <div class="line-value">{{info.orderInfo.status_text}}</div>
        </div>
        <div class="order-line" v-if="info.orderInfo.file">
          <div class="line-title">合同</div>
          <div class="line-value">
            <a target="_blank" :href="$url.cdn(info.orderInfo.file.url)" title="点击查看文件">{{info.orderInfo.file.name}}</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import contractApi from '@/api/contract'
  export default {
    data() {
      return {
        info: {}
      };
    },
    methods: {
      async getInfo() {
        let {data} =  await contractApi.order.detail(this.$route.params.id)
        this.info = data;
      },
    },
    created() {
      this.$emit("getCompontsIndex", 1);
      this.getInfo();
    }
  };
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>
